import React from 'react';
import '../template-file-css/document-file-template.css'; 


export const RHCA_ChildAndAdolescentBha = ({
    itemsRef,
    showErrorFor, 
}) => {

    return (
        <form id='RHCA_ChildAndAdolescentBha' className='file-pdf-document'>
            <div className='file-template'> 


                <h3>C&A BEHAVIORAL HEALTH ASSESSMENT</h3>
                <h4>A.	DEMOGRAPHIC INFORMATION (COMPLETE ALL INFORMATION)</h4>
                <p className='w-750'>

                    <input type="checkbox" name="chkInitial1" id="chkInitial1" className='add-only' value="Initial1" /> Initial
                    &nbsp;
                    <input type="checkbox" name="chkInitial2" id="chkInitial2" className='add-only' value="Initial2" /> Re-Assessment
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Gender</span>
                            <input type="radio" id="rbMedications_Yes" name="rb_Medications" className='add-only' value="1" /> Male &nbsp;
                            <input type="radio" id="rbMedications_Ys" name="rb_Medications" className='add-only' value="0" /> Female &nbsp;
                            <input type="radio" id="rbMedications_Ye" name="rb_Medications" className='add-only' value="2" /> Other:  &nbsp;
                            <input type='text' id="txtEmergencyOther" name="txtEmergencyOther" className='add-only w-250 custom-add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Referral Source:</span>
                    <textarea id="txtReferralSource" name="txtReferralSource" className='add-only'></textarea>
                </p>
                <h4>INSURANCE INFORMATION</h4>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Insurance Type</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cbMedicaid1" name="cbMedicaid1" className='add-only' value="Medicaid1" /> Medicaid Standard:
                            <input type="text" id="txtMedicaid1" name="txtMedicaid1" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type="checkbox" id="cbMedicaid2" name="cbMedicaid2" className='add-only' value="Medicaid2" /> Peachstate:
                            <input type="text" id="txtMedicaid2" name="txtMedicaid2" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cbMedicaid3" name="cbMedicaid3" className='add-only' value="Medicaid3" /> Amerigroup:
                            <input type="text" id="txtMedicaid3" name="txtMedicaid3" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type="checkbox" id="cbMedicaid4" name="cbMedicaid4" className='add-only' value="Medicaid4" /> Caresource:
                            <input type="text" id="txtMedicaid4" name="txtMedicaid4" className='add-only' />
                        </td>
                    </tr>
                </table>
                <h4>
                    B. INDIVIDUAL PRESENTATION & PRESENTING PROBLEM
                </h4>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Location of assessment?</span>
                            <input type="text" id="txtLocation" name="txtLocation" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Who was present during assessment?</span>
                            <input type="text" id="txtAssessment" name="txtAssessment" className='add-only' />
                        </td>
                    </tr>
                </table>
                <h3>INTERVIEW OBSERVATIONS</h3>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Appearance</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type="checkbox" id="cbAppearance_1" name="cbAppearance_1" className='add-only' value="Appearance1" /> Well groomed
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbAppearance_2" name="cbAppearance_2" className='add-only' value="Appearance2" /> Unkempt
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbAppearance_3" name="cbAppearance_3" className='add-only' value="Appearance3" /> Disheveled
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbAppearance_4" name="cbAppearance_4" className='add-only' value="Appearance4" /> Malodorous
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Build</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type="checkbox" id="cbBuild_1" name="cbBuild_1" className='add-only' value="Build1" /> Average
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbBuild_2" name="cbBuild_2" className='add-only' value="Build2" /> Thin
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbBuild_3" name="cbBuild_3" className='add-only' value="Build3" /> Overweight
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbBuild_4" name="cbBuild_4" className='add-only' value="Build4" /> Obese
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Demeanor</span></td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type="checkbox" id="cbDemeanor_1" name="cbDemeanor_1" className='add-only' value="Demeanor1" /> Cooperative
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbDemeanor_2" name="cbDemeanor_2" className='add-only' value="Demeanor2" /> Hostile
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbDemeanor_3" name="cbDemeanor_3" className='add-only' value="Demeanor3" /> Guarded
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbDemeanor_4" name="cbDemeanor_4" className='add-only' value="Demeanor4" /> Withdrawn
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type="checkbox" id="cbDemeanor_5" name="cbDemeanor_5" className='add-only' value="Demeanor5" /> Preoccupied
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbDemeanor_6" name="cbDemeanor_6" className='add-only' value="Demeanor6" /> Demanding
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbDemeanor_7" name="cbDemeanor_7" className='add-only' value="Demeanor7" /> Seductive
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Eye Contact</span></td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type="checkbox" id="cbEye_1" name="cbEye_1" className='add-only' value="Eye1" /> Average
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbEye_2" name="cbEye_2" className='add-only' value="Eye2" /> Decreased
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbEye_3" name="cbEye_3" className='add-only' value="Eye3" /> Increased
                        </td>
                        <td className='w-187'>&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Speech</span></td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type="checkbox" id="cbSpeech_1" name="cbSpeech_1" className='add-only' value="Speech1" /> Clear
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbSpeech_2" name="cbSpeech_2" className='add-only' value="Speech2" /> Slurred
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbSpeech_3" name="cbSpeech_3" className='add-only' value="Speech3" /> Rapid
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbSpeech_4" name="cbSpeech_4" className='add-only' value="Speech4" /> Slow
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type="checkbox" id="cbSpeech_5" name="cbSpeech_5" className='add-only' value="5" /> Pressured
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbSpeech_6" name="cbSpeech_6" className='add-only' value="6" /> Soft
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbSpeech_7" name="cbSpeech_7" className='add-only' value="7" /> Loud
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbSpeech_8" name="cbSpeech_8" className='add-only' value="8" /> Monotone
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Mental Status: </span><span className='small'>(Describe Individual mood, affect, thought processes, though contact, AVH, intelligence, insight, judgment, and orientation)</span>
                    Please indicate age, race, marital status here. Please describe the individual (short, tall, slim, obese, hair color, skin color, any unique characteristics (tattoos, burns, piercings etc)) Make sure the description in this box matches the check marks above. Be sure to indicate the location of the assessment.
                    <textarea id="txtChecked1" name="txtChecked1" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    For Telehealth (must state): Behavioral Health Assessment was held via telehealth and parent/guardian consented to
                    the use of telehealth. Assessor assessed the individual's location and checked for safety. Individual and
                    parent/guardian were at their home during the time of the assessment. Assessment was held in compliance with
                    DBHDD policies and procedures using a HIPAA/BAA-compliant telehealth platform.
                </p>
                <h4>PRESENTING PROBLEM AND REQUESTED SERVICE</h4>
                <p className='w-750'>
                    <span className='eleHeader'>What is the Individual's presenting problem/why are they here?</span>
                    <span className='small'>(This should be in the Individual's own words as well as a description from Assessor regarding the symptoms that Individual ha s that qualifies DSM-5 diagnosis.)</span>
                    Please place in quotes, using the client's words, the main reason the individual wants services.
                    <textarea id="txtChecked2" name="txtChecked2" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    This section should be at least two paragraphs long. The first paragraph should provide information on the client's perspective of
                    the problem and why they are seeking treatment
                </p>
                <p className='w-750'>
                    In the second paragraph use clinical terms to explain why they are here... be sure to indicate the specific clinical symptoms (crying,
                    isolation, hearing voices, etc). Then describe how long they have had them, how often they occur and if they are less or more
                    frequent than in the past. If there are any significant events (suicide, homicide, probation, jail time, death in the family, etc)
                    please be sure to obtain the date when those instances occurred.
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>What is the parent's/family's perception of the problem?</span>
                    Please indicate what the family thinks the challenges are with the individual. Example: Mom expressed, I think Jane has been acting out at school because she is not talking about her emotions surrounding her dad and I getting a divorce.
                    <textarea id="txtChecked3" name="txtChecked3" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Describe precipitating events:</span><span className='small'>Include the onset of the problem, duration, frequency, past intervention/services and the results of the services.</span>
                    <textarea id="txtChecked4" name="txtChecked4" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>What services is the parent/family asking for?</span>
                    Indicate what services the family would like, ex: individual therapy, family therapy, psychiatric, etc. Remember we no longer use the term CORE. NIOP should be used instead.
                    <textarea id="txtChecked5" name="txtChecked5" className='add-only'></textarea>
                </p>
                <h4>
                    C. RISK AND TRAUMA ASSESSMENT (INCLUDE ABUSE/NEGLECT)<span className='small'>
                        Check all that apply</span>
                </h4>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Suicidality</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type="checkbox" id="cbOrientation_1" name="cbOrientation_1" className='add-only' value="Suicidality1" /> None
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbOrientation_2" name="cbOrientation_2" className='add-only' value="Suicidality2" /> Ideation
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbOrientation_3" name="cbOrientation_3" className='add-only' value="Suicidality3" /> Plan
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbOrientation_4" name="cbOrientation_4" className='add-only' value="Suicidality4" /> Intent w/o means
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbOrientation_5" name="cbOrientation_5" className='add-only' value="Suicidality5" /> Intent w/means
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Homicidality</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type="checkbox" id="cbHomicidality_1" name="cbHomicidality_1" className='add-only' value="Homicidality1" /> None
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbHomicidality_2" name="cbHomicidality_2" className='add-only' value="Homicidality2" /> Ideation
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbHomicidality_3" name="cbHomicidality_3" className='add-only' value="Homicidality3" /> Plan
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbHomicidality_4" name="cbHomicidality_4" className='add-only' value="Homicidality4" /> Intent w/o means
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type="checkbox" id="cbHomicidality_5" name="cbHomicidality_5" className='add-only' value="Homicidality5" /> Intent w/means
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>If risk exists, Individual is able to contract not to harm:</span>
                    <input type="radio" id="rbMedications11_Yes" name="rbMedications11" className='add-only' value="1" /> Self
                    &nbsp;
                    <input type="radio" id="rbMedications11_No" name="rbMedications11" className='add-only' value="0" /> Others
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Impulse Control</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type="checkbox" id="cbImpulse_1" name="cbImpulse_1" className='add-only' value="Impulse1" /> Sufficient
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbImpulse_2" name="cbImpulse_2" className='add-only' value="Impulse2" /> Moderate
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbImpulse_3" name="cbImpulse_3" className='add-only' value="Impulse3" /> Minimal
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbImpulse_4" name="cbImpulse_4" className='add-only' value="Impulse4" /> Inconsistent
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type="checkbox" id="cbImpulse_5" name="cbImpulse_5" className='add-only' value="Impulse5" /> Explosive
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Substance Abuse</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type="checkbox" id="cbSubstance_1" name="cbSubstance_1" className='add-only' value="Substance1" /> None
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbSubstance_2" name="cbSubstance_2" className='add-only' value="Substance2" /> Abuse
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbSubstance_3" name="cbSubstance_3" className='add-only' value="Substance3" /> Dependence
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbSubstance_4" name="cbSubstance_4" className='add-only' value="Substance4" /> Unstable remission
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Medical Risks</span>
                    <input type="radio" id="rbMedications35_Yes" name="rbMedications35" className='add-only' value="1" /> None
                    <input type="radio" id="rbMedications35_No" name="rbMedications35" className='add-only' value="0" /> Yes. Explain:
                    <textarea id="txtMedical3" name="txtMedical3" className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Neglect</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type="checkbox" id="cbNeglect_1" name="cbNeglect_1" className='add-only' value="Neglect1" />  Physical
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbNeglect_2" name="cbNeglect_2" className='add-only' value="Neglect2" /> Emotional
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbNeglect_3" name="cbNeglect_3" className='add-only' value="Neglect3" />  Nutritional
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbNeglect_4" name="cbNeglect_4" className='add-only' value="Neglect4" /> Educational
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type="checkbox" id="cbNeglect_5" name="cbNeglect_5" className='add-only' value="Neglect5" /> Medical
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Abuse</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type="checkbox" id="cbAbuse_1" name="cbAbuse_1" className='add-only' value="Abuse1" /> Verbal/Emotional
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbAbuse_2" name="cbAbuse_2" className='add-only' value="Abuse2" /> Physical
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbAbuse_3" name="cbAbuse_3" className='add-only' value="Abuse3" />  Sexual
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbAbuse_4" name="cbAbuse_4" className='add-only' value="Abuse4" /> Family Violence
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type="checkbox" id="cbAbuse_5" name="cbAbuse_5" className='add-only' value="Abuse5" />
                            None
                        </td>
                        <td className='w-187'>
                            &nbsp;
                        </td>
                        <td className='w-187'>&nbsp;
                        </td>
                        <td className='w-187'>&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Trauma</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type="checkbox" id="cbThought_1" name="cbThought_1" className='add-only' value="Trauma1" /> Deaths
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbThought_2" name="cbThought_2" className='add-only' value="Trauma2" /> Separation from family
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbThought_3" name="cbThought_3" className='add-only' value="Trauma3" />  Abuse
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbThought_4" name="cbThought_4" className='add-only' value="Trauma4" /> Violence
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type="checkbox" id="cbThought_6" name="cbThought_6" className='add-only' value="Trauma6" />  None
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type="checkbox" id="cbThought_5" name="cbThought_5" className='add-only' value="Trauma5" /> Other
                            <input type="text" name="txtTrauma" id="txtTrauma" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Risky Behaviors</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type="checkbox" id="cbContent_1" name="cbContent_1" className='add-only' value="Risky1" />  Unprotected Sex
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbContent_2" name="cbContent_2" className='add-only' value="Risky2" /> Shoplifting
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbContent_3" name="cbContent_3" className='add-only' value="Risky3" /> Reckless Driving
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbContent_4" name="cbContent_4" className='add-only' value="Risky4" /> Gang Involvement
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type="checkbox" id="cbContent_5" name="cbContent_5" className='add-only' value="Risky5" /> None
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbContent_6" name="cbContent_6" className='add-only' value="Risky6" /> Drug Dealing
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbContent_7" name="cbContent_7" className='add-only' value="Risky7" /> Carrying/Using Weapon
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbContent_8" name="cbContent_8" className='add-only' value="Risky8" /> Prostitution
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type="checkbox" id="cbContent_9" name="cbContent_9" className='add-only' value="Risky9" /> Eating Disorder
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type="checkbox" id="cbContent_10" name="cbContent_10" className='add-only' value="Risky10" /> Other
                            <input type="text" name="txtRisky" id="txtRisky" className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>If any of the above were checked, please provide details below. </span><span className='small'>Include dates, names of perpetrators, if abuse/risk was reported, DFCS/CPS involvement, interventions, and outcome.
                    </span>
                    <textarea id="txtDates" name="txtDates" className='add-only'></textarea>
                </p>
                <h3>D. FAMILY ASSESSMENT</h3>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='small'>HOUSEHOLD COMPOSITION AT TIME OF ASSESSMENT
                            </span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-175'>
                            <span className='eleHeader'>Name</span>
                        </td>
                        <td className='w-350'>
                            <span className='eleHeader'>Relationship to Individual</span>
                        </td>
                        <td className='w-150'>
                            <span className='eleHeader'>Date of Birth</span>
                        </td>
                        <td className='w-75'>
                            <span className='eleHeader'>Age</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-175'>
                            <input type="text" name="txtName1" id="txtName1" className='add-only' />
                        </td>
                        <td className='w-350'>
                            <input type="text" name="txtRelationship1" id="txtRelationship1" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="date" name="txtDateBirth1" id="txtDateBirth1" className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type="text" name="txtAge1" id="txtAge1" className='add-only' />
                        </td>
                    </tr>

                    <tr>
                        <td className='w-175'>
                            <input type="text" name="txtName2" id="txtName2" className='add-only' />
                        </td>
                        <td className='w-350'>
                            <input type="text" name="txtRelationship2" id="txtRelationship2" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="date" name="txtDateBirth2" id="txtDateBirth2" className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type="text" name="txtAge2" id="txtAge2" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-175'>
                            <input type="text" name="txtName3" id="txtName3" className='add-only' />
                        </td>
                        <td className='w-350'>
                            <input type="text" name="txtRelationship3" id="txtRelationship3" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="date" name="txtDateBirth3" id="txtDateBirth3" className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type="text" name="txtAge3" id="txtAge3" className='add-only' />
                        </td>
                    </tr>
                </table>
                <h4>
                    The following individuals are involved and invested in my treatment and recovery.
                </h4>
                <h4>
                    An ROI is required for these individuals:
                </h4>
                <table>
                    <tr>
                        <td className='w-200'>
                            <span className='eleHeader'>Name:</span>
                            <input type="text" name="txtNameRoi1" id="txtNameRoi1" className='add-only' />
                        </td>
                        <td className='w-200'>
                            <span className='eleHeader'>Relationship to Individual</span>
                            <input type="text" name="txtRelationshipIndividual1" id="txtRelationshipIndividual1" className='add-only' />
                        </td>
                        <td className='w-200'>
                            <span className='eleHeader'>Phone Number</span>
                            <input type="text" name="txtPhoneNumber1" id="txtPhoneNumber1" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <span className='eleHeader'>ROI Complete?</span>
                            <input type="radio" id="rbComplete_Yes" name="rb_Complete" className='add-only' value="1" /> Yes &nbsp;
                            <input type="radio" id="rbComplete_No" name="rb_Complete" className='add-only' value="0" /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            <input type="text" name="txtNameRoi2" id="txtNameRoi2" className='add-only' />
                        </td>
                        <td className='w-200'>
                            <input type="text" name="txtRelationshipIndividual2" id="txtRelationshipIndividual2" className='add-only' />
                        </td>
                        <td className='w-200'>
                            <input type="text" name="txtPhoneNumber2" id="txtPhoneNumber2" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="radio" id="rbComplete2_Yes" name="rb_Complete2" className='add-only' value="1" /> Yes &nbsp;
                            <input type="radio" id="rbComplete2_No" name="rb_Complete2" className='add-only' value="0" /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            <input type="text" name="txtNameRoi3" id="txtNameRoi3" className='add-only' />
                        </td>
                        <td className='w-200'>
                            <input type="text" name="txtRelationshipIndividual3" id="txtRelationshipIndividual3" className='add-only' />
                        </td>
                        <td className='w-200'>
                            <input type="text" name="txtPhoneNumber3" id="txtPhoneNumber3" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="radio" id="rbComplete3_Yes" name="rb_Complete3" className='add-only' value="1" /> Yes &nbsp;
                            <input type="radio" id="rbComplete3_No" name="rb_Complete3" className='add-only' value="0" /> No
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>LIVING SITUATION </span><span className='small'>(Check all that apply)</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbOrigin_1" name="cbOrigin_1" className='add-only' value="Origin1" /> Home w/family of origin
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbOrigin_2" name="cbOrigin_2" className='add-only' value="Origin2" /> Independent Living
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbOrigin_3" name="cbOrigin_3" className='add-only' value="Origin3" /> Group Home/Foster Home
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbOrigin_4" name="cbOrigin_4" className='add-only' value="Origin4" /> Homeless
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbOrigin_5" name="cbOrigin_5" className='add-only' value="Origin5" />  Adequate Housing
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbOrigin_6" name="cbOrigin_6" className='add-only' value="Origin6" />  Safety Risks/Hazardous
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbOrigin_7" name="cbOrigin_7" className='add-only' value="Origin7" /> Overcrowded
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbOrigin_8" name="cbOrigin_8" className='add-only' value="Origin8" /> Risk of Homelessness
                        </td>
                        <td className='w-250'>
                            &nbsp;
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>What is the family's source(s) of income? Is income monthly, bi-weekly? Is income sufficient for household expenses?</span>
                    <textarea id="txtSource" placeholder="Must Complete. Find out the source of income and how much. Please indicate how long they have lived at their current address in this section as well." name="txtSource" className='add-only'></textarea>
                </p>
                <h4>
                    FAMILY HISTORY
                </h4>
                <p className='w-750'>
                    <span className='eleHeader'>Medical Problems </span><span className='small'>(Heart Disease, Lung Disease,
                        Cancer, Strokes, Dementia, Diabetes, Asthma, etc)</span>
                    <textarea id="txtMedicalProblems1" name="txtMedicalProblems1" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Substance Abuse </span><span className='small'>(Alcohol, Cocaine, Cannabis,
                        Stimulants, Inhalants, Hallucinogens, Sedatives, Designer Drugs)</span>
                    <textarea id="txtMedicalProblems2" name="txtMedicalProblems2" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Mental Illnesses/Bx Problems</span><span className='small'>(depression,
                        schizophrenia, bipolar disorder, anxiety, ADD, ADHD, Learning Disorders, School Behavior Problems, Incarcerations, Gambling)</span>
                    <textarea id="txtMedicalProblems3" name="txtMedicalProblems3" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Describe Individual relationship with biological parents.</span>
                    <textarea id="txtMedicalProblems4" name="txtMedicalProblems4" placeholder="If the individual does not reside with biological parents, please explain why and provide details on their relationship with current guardian." className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Describe Individual relationship with siblings.</span>
                    <textarea id="txtMedicalProblems5" name="txtMedicalProblems5" className='add-only'></textarea>
                </p>
                <h3>
                    E. MEDICAL ASSESSMENT
                </h3>
                <p className='w-750'>
                    <span className='eleHeader'>What medical problems does the Individual have?</span><span className='small'>(Include specific diagnosis, when problem was diagnosed, interventions)</span>
                    <textarea id="txtMedicalProblems6" name="txtMedicalProblems6" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>What was the Individual health at birth? Early development?</span><span className='small'>(Include any delays with walking, crawling, sitting up, concerns with height/weight, any problems with running, jumping, climbing, balancing, coordination, problems with hearing,
                        vision or speech; current with immunizations)</span>
                    <textarea id="txtMedicalProblems7" name="txtMedicalProblems7" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>What is the Individual prenatal history?</span><span className='small'>(Include any substance abuse, physical abuse, medications, and illnesses during mother's pregnancy, prenatal exposure to alcohol, tobacco and other drugs)</span>
                    <textarea id="txtMedicalProblems8" name="txtMedicalProblems8" className='add-only'></textarea>
                </p>
                <h4>PRESCRIBED MEDICATIONS<span className='small'>(Include both medical and psychiatric medications)</span></h4>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'> 1. Medication Name</span>
                            <input type="text" id="txtMedicationName_1" name="txtMedicationName_1" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'><b>Dose/Frequency</b></td>
                        <td className='w-550'> <input type="text" id="txtDose_1" name="txtDose_1" className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-200'><b> Prescribed by?</b></td>
                        <td className='w-550'> <input type="text" id="txtPrescribedBy_1" name="txtPrescribedBy_1" className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-200'><b> When prescribed?</b></td>
                        <td className='w-550'> <input type="text" id="txtPrescribedWhen_1" name="txtPrescribedWhen_1" className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-200'><b> When is next refill?</b></td>
                        <td className='w-550'> <input type="text" id="txtNextRefill_1" name="txtNextRefill_1" className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-200'><b> Side Effects?</b></td>
                        <td className='w-550'> <input type="text" id="txtSideEffects_1" name="txtSideEffects_1" className='add-only' /> </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>2. Medication Name</span>
                            <input type="text" id="txtMedicationName_2" name="txtMedicationName_2" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'><b>Dose/Frequency</b></td>
                        <td className='w-550'> <input type="text" id="txtDose_2" name="txtDose_2" className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-200'><b> Prescribed by?</b></td>
                        <td className='w-550'> <input type="text" id="txtPrescribedBy_2" name="txtPrescribedBy_2" className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-200'><b> When prescribed?</b></td>
                        <td className='w-550'> <input type="text" id="txtPrescribedWhen_2" name="txtPrescribedWhen_2" className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-200'><b> When is next refill?</b></td>
                        <td className='w-550'> <input type="text" id="txtNextRefill_2" name="txtNextRefill_2" className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-200'><b> Side Effects?</b></td>
                        <td className='w-550'> <input type="text" id="txtSideEffects_2" name="txtSideEffects_2" className='add-only' /> </td>
                    </tr>
                </table>



                <p className='w-750'>
                    <span className='eleHeader'>Is Individual compliant with medications?</span>
                    <input type="radio" id="rbMedications3_Yes" name="rbMedications3" className='add-only' value="1" /> Yes &nbsp;
                    <input type="radio" id="rbMedications3_No" name="rbMedications3" className='add-only' value="0" /> No, explain:
                    <textarea id="txtMedExplain" name="txtMedExplain" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Current Pediatrician/Primary Care Physician:</span><span className='small'>If Individual does not have a
                        doctor please type: "Family reported not having PCP; will provide resources" Let the CM know when you submit your assessment  </span>
                    <textarea id="txtMedCurrent" name="txtMedCurrent" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    Telephone No. <input type="text" id="txtTelephoneNo" name="txtTelephoneNo" className='add-only' />
                </p>
                <h3>
                    NUTRITIONAL SCREENING
                </h3>
                <h4>
                    Nutritional Status
                </h4>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Current Weight:</span>
                            <input type="text" id="txtWeight" placeholder="Must Complete" name="txtWeight" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Current Height:</span>
                            <input type="text" id="txtHeight" placeholder="Must Complete" name="txtHeight" className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Appetite</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="radio" id="rbAppetite_Good" name="rbAppetite" className='add-only' value="Good" /> Good
                        </td>
                        <td className='w-250'>
                            <input type="radio" id="rbAppetite_Fair" name="rbAppetite" className='add-only' value="Fair" /> Fair
                        </td>
                        <td className='w-250'>
                            <input type="radio" id="rbAppetite_Poor" name="rbAppetite" className='add-only' value="Poor" /> Poor,explain below
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <textarea id="txtExplainBelow" name="txtExplainBelow" className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Eating Behavior</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbEating_1" name="cbEating_1" className='add-only' value="Eating1" /> Binges/overeats to excess
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbEating_2" name="cbEating_2" className='add-only' value="Eating2" />  Hiding/Hoarding food
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbEating_3" name="cbEating_3" className='add-only' value="Eating3" />  Normal Eating Behavior
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbEating_4" name="cbEating_4" className='add-only' value="Eating4" /> Restricts food/vomits/over-exercises to avoid weight gain
                        </td>
                        <td className='w-250'>
                            &nbsp;
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Other</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cbOther_Gain1" name="cbOther_Gain1" className='add-only' value="Gained1" />  Recently gained/lost significant weight
                        </td>
                        <td className='w-375'>
                            <input type="checkbox" id="cbOther_Diet" name="cbOther_Diet" className='add-only' value="Dietary1" />  Special Dietary Needs
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbOther_Gain2" name="cbOther_Gain2" className='add-only' value="Gained2" /> Allergies, explain below
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <textarea id="txtAllergies" name="txtAllergies" className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>ASSISTIVE OR ADAPTIVE DEVICES</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbDevices_None" name="cbDevices_None" className='add-only' value="None1" /> None
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbDevices_Glasses" name="cbDevices_Glasses" className='add-only' value="Glasses1" /> Glasses
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbDevices_Walker" name="cbDevices_Walker" className='add-only' value="Walker1" /> Walker
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbDevices_Braille" name="cbDevices_Braille" className='add-only' value="Braille1" /> Braille
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbDevices_Hearing" name="cbDevices_Hearing" className='add-only' value="Hearing1" /> Hearing Aids
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbDevices_Cane" name="cbDevices_Cane" className='add-only' value="Cane1" /> Cane
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbDevices_Crutches" name="cbDevices_Crutches" className='add-only' value="Crutches1" /> Crutches
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbDevices_Wheelchair" name="cbDevices_Wheelchair" className='add-only' value="Wheelchair1" /> Wheelchair
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbDevices_Translated" name="cbDevices_Translated" className='add-only' value="Translated1" /> Translated Written Information
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbDevices_Translator" name="cbDevices_Translator" className='add-only' value="Translator1" /> Translator for Speaking
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbDevices_Other" name="cbDevices_Other" className='add-only' value="Other1" /> Other:
                            <input type="text" id="txtOther" name="txtOther" className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>If any of the above were checked, please provide details below.</span>
                    <textarea id="txtCheckedDetails" name="txtCheckedDetails" className='add-only'></textarea>
                </p>
                <h3>
                    F. BEHAVIOR AND MENTAL HEALTH ASSESSMENT
                </h3>
                <h4>
                    Please complete the below checklist for symptoms:
                </h4>
                <h4>
                    Key:
                </h4>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Severity Rating:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="radio" id="rbSeverity_Yes" name="rbSeverity" className='add-only' value="1" /> 1=Mild
                        </td>
                        <td className='w-250'>
                            <input type="radio" id="rbSeverity_No" name="rbSeverity" className='add-only' value="0" /> 2=Moderate
                        </td>
                        <td className='w-250'>
                            <input type="radio" id="rbSeverity_Np" name="rbSeverity" className='add-only' value="2" /> 3=Severe
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Duration Rating:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="radio" id="rbSeverity1_Yes" name="rbSeverity1" className='add-only' value="1" /> 1=Less than 1 Month
                        </td>
                        <td className='w-250'>
                            <input type="radio" id="rbSeverity1_No" name="rbSeverity1" className='add-only' value="0" /> 2=1 to 6 Months
                        </td>
                        <td className='w-250'>
                            <input type="radio" id="rbSeverity1_Np" name="rbSeverity1" className='add-only' value="2" /> 3=7 to 11 Months
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="radio" id="rbSeverity1_Ys" name="rbSeverity1" className='add-only' value="3" /> 4=More than 1 Year
                        </td>
                        <td className='w-250'>
                            &nbsp;
                        </td>
                        <td className='w-250'>
                            &nbsp;
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Symptom/Problem</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Severity</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Duration</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            1. Anxiety
                        </td>
                        <td className='w-250'>
                            <input type="text" name="txtSeverity1" id="txtSeverity1" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" name="txtDuration1" id="txtDuration1" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            2. Appetite Problems
                        </td>
                        <td className='w-250'>
                            <input type="text" name="txtSeverity2" id="txtSeverity2" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" name="txtDuration2" id="txtDuration2" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            3. Bizarre Behavior
                        </td>
                        <td className='w-250'>
                            <input type="text" name="txtSeverity3" id="txtSeverity3" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" name="txtDuration3" id="txtDuration3" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            4. Bizarre Ideations (Delusions)
                        </td>
                        <td className='w-250'>
                            <input type="text" name="txtSeverity4" id="txtSeverity4" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" name="txtDuration4" id="txtDuration4" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            5. Conduct Problems
                        </td>
                        <td className='w-250'>
                            <input type="text" name="txtSeverity5" id="txtSeverity5" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" name="txtDuration5" id="txtDuration5" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            6. Depression
                        </td>
                        <td className='w-250'>
                            <input type="text" name="txtSeverity6" id="txtSeverity6" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" name="txtDuration6" id="txtDuration6" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            7. Eating Disorder
                        </td>
                        <td className='w-250'>
                            <input type="text" name="txtSeverity7" id="txtSeverity7" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" name="txtDuration7" id="txtDuration7" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            8. Family Problems
                        </td>
                        <td className='w-250'>
                            <input type="text" name="txtSeverity8" id="txtSeverity8" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" name="txtDuration8" id="txtDuration8" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            9. Gender Issues
                        </td>
                        <td className='w-250'>
                            <input type="text" name="txtSeverity9" id="txtSeverity9" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" name="txtDuration9" id="txtDuration9" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            10. Impaired Memory
                        </td>
                        <td className='w-250'>
                            <input type="text" name="txtSeverity10" id="txtSeverity10" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" name="txtDuration10" id="txtDuration10" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            11. Indep. Living Problems
                        </td>
                        <td className='w-250'>
                            <input type="text" name="txtSeverity11" id="txtSeverity11" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" name="txtDuration11" id="txtDuration11" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            12. Lack of Support System
                        </td>
                        <td className='w-250'>
                            <input type="text" name="txtSeverity12" id="txtSeverity12" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" name="txtDuration12" id="txtDuration12" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            13. Loss of Energy
                        </td>
                        <td className='w-250'>
                            <input type="text" name="txtSeverity13" id="txtSeverity13" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" name="txtDuration13" id="txtDuration13" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            14. Loss of Interest
                        </td>
                        <td className='w-250'>
                            <input type="text" name="txtSeverity14" id="txtSeverity14" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" name="txtDuration14" id="txtDuration14" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            15. Obsessive/Compulsive
                        </td>
                        <td className='w-250'>
                            <input type="text" name="txtSeverity15" id="txtSeverity15" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" name="txtDuration15" id="txtDuration15" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            16. Panic Attacks
                        </td>
                        <td className='w-250'>
                            <input type="text" name="txtSeverity16" id="txtSeverity16" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" name="txtDuration16" id="txtDuration16" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            17. Paranoid Ideation
                        </td>
                        <td className='w-250'>
                            <input type="text" name="txtSeverity17" id="txtSeverity17" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" name="txtDuration17" id="txtDuration17" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            18. Phobia
                        </td>
                        <td className='w-250'>
                            <input type="text" name="txtSeverity18" id="txtSeverity18" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" name="txtDuration18" id="txtDuration18" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            19. Poor Interpersonal Skills
                        </td>
                        <td className='w-250'>
                            <input type="text" name="txtSeverity19" id="txtSeverity19" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" name="txtDuration19" id="txtDuration19" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            20. Poor Judgment
                        </td>
                        <td className='w-250'>
                            <input type="text" name="txtSeverity20" id="txtSeverity20" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" name="txtDuration20" id="txtDuration20" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            21. Poor Self Care Skills
                        </td>
                        <td className='w-250'>
                            <input type="text" name="txtSeverity21" id="txtSeverity21" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" name="txtDuration21" id="txtDuration21" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            22. School Problems
                        </td>
                        <td className='w-250'>
                            <input type="text" name="txtSeverity22" id="txtSeverity22" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" name="txtDuration22" id="txtDuration22" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            23. Sexual Acting Out
                        </td>
                        <td className='w-250'>
                            <input type="text" name="txtSeverity23" id="txtSeverity23" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" name="txtDuration23" id="txtDuration23" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            24. Sleep Problems
                        </td>
                        <td className='w-250'>
                            <input type="text" name="txtSeverity24" id="txtSeverity24" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" name="txtDuration24" id="txtDuration24" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            25. Somatization
                        </td>
                        <td className='w-250'>
                            <input type="text" name="txtSeverity25" id="txtSeverity25" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" name="txtDuration25" id="txtDuration25" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            26. Unusual Body Movements
                        </td>
                        <td className='w-250'>
                            <input type="text" name="txtSeverity26" id="txtSeverity26" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" name="txtDuration26" id="txtDuration26" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            27. Other: <input type="text" name="txtDurationOther" id="txtDurationOther" className='add-only w-150' />
                        </td>
                        <td className='w-250'>
                            <input type="text" name="txtSeverity27" id="txtSeverity27" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" name="txtDuration27" id="txtDuration27" className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>If any of the above were checked, please provide specific details below. Please indicate frequency and intensity of symptoms.</span>
                </p>
                <p className='w-750'>Please describe in detail any items that were checked above.
                    <textarea id="txtMedCondition1" name="txtMedCondition1" className='add-only'></textarea>

                </p>
                <p className='w-750'>
                    Then describe how long they have had them (duration), how often they occur (frequency) and if they are less or more frequent then in the past (intensity).
                    <textarea id="txtMedCondition2" name="txtMedCondition2" className='add-only'></textarea>

                </p>
                <p className='w-750'>
                    Each symptom listed in this section MUST be addressed in the treatment plan.
                    <textarea id="txtMedCondition3" name="txtMedCondition3" className='add-only'></textarea>

                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Has Individual ever been diagnosed with a mental health problem?</span><span className='small'>(Include specific diagnosis, when problem was diagnosed, interventions)</span>
                    Please describe in detail any items that were checked above.
                    <textarea id="txtMedCondition5" name="txtMedCondition5" className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-150'><span className='eleHeader'>Date(s)</span></td>
                        <td className='w-150'><span className='eleHeader'>Location</span></td>
                        <td className='w-150'><span className='eleHeader'>Type of Treatment (Outpatient, Inpatient, etc)</span></td>
                        <td className='w-150'><span className='eleHeader'>Diagnosis Given</span></td>
                        <td className='w-150'><span className='eleHeader'>Outcome (i.e., stabilized, withdrew from services, etc.)</span></td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type="date" id="txtDate1" name="txtDate1" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtLocation1" name="txtLocation1" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtTreatment1" name="txtTreatment1" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtDiagnosis1" name="txtDiagnosis1" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtOutcome1" name="txtOutcome1" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type="date" id="txtDate2" name="txtDate2" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtLocation2" name="txtLocation2" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtTreatment2" name="txtTreatment2" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtDiagnosis2" name="txtDiagnosis2" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtOutcome2" name="txtOutcome2" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type="date" id="txtDate3" name="txtDate3" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtLocation3" name="txtLocation" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtTreatment3" name="txtTreatment3" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtDiagnosis3" name="txtDiagnosis3" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtOutcome3" name="txtOutcome3" className='add-only' />
                        </td>
                    </tr>
                </table>
                <h4>
                    SUBSTANCE ABUSE INFORMATION
                </h4>

                <table>
                    <tr>
                        <td className='w-200'><span className='eleHeader'>Substance Name</span></td>
                        <td className='w-100'><span className='eleHeader'>Age of 1st Use</span></td>
                        <td className='w-100'><span className='eleHeader'>Age of Heaviest Use</span></td>
                        <td className='w-200'><span className='eleHeader'>Frequency/Amount</span></td>
                        <td className='w-150'><span className='eleHeader'>Date of Last use</span></td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            Alcohol
                        </td>
                        <td className='w-100'>
                            <input type="text" id="txtAgeIst1" name="txtAgeIst1" className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type="text" id="txtAgHeaviest1" name="txtAgHeaviest1" className='add-only' />
                        </td>
                        <td className='w-200'>
                            <input type="text" id="txtFrequency1" name="txtFrequency1" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="date" id="txtDateLast1" name="txtDateLast1" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            Cannabis
                        </td>
                        <td className='w-100'>
                            <input type="text" id="txtAgeIst2" name="txtAgeIst2" className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type="text" id="txtAgHeaviest2" name="txtAgHeaviest2" className='add-only' />
                        </td>
                        <td className='w-200'>
                            <input type="text" id="txtFrequency2" name="txtFrequency2" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="date" id="txtDateLast2" name="txtDateLast2" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            Cocaine
                        </td>
                        <td className='w-100'>
                            <input type="text" id="txtAgeIst3" name="txtAgeIst3" className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type="text" id="txtAgHeaviest3" name="txtAgHeaviest3" className='add-only' />
                        </td>
                        <td className='w-200'>
                            <input type="text" id="txtFrequency3" name="txtFrequency3" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="date" id="txtDateLast3" name="txtDateLast3" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            Stimulants<span className='small'>
                                (Crystal, speed, amphetamines)  </span>
                        </td>
                        <td className='w-100'>
                            <input type="text" id="txtAgeIst4" name="txtAgeIst4" className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type="text" id="txtAgHeaviest4" name="txtAgHeaviest4" className='add-only' />
                        </td>
                        <td className='w-200'>
                            <input type="text" id="txtFrequency4" name="txtFrequency4" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="date" id="txtDateLast4" name="txtDateLast4" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            Methamphetamine
                        </td>
                        <td className='w-100'>
                            <input type="text" id="txtAgeIst5" name="txtAgeIst5" className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type="text" id="txtAgHeaviest5" name="txtAgHeaviest5" className='add-only' />
                        </td>
                        <td className='w-200'>
                            <input type="text" id="txtFrequency5" name="txtFrequency5" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="date" id="txtDateLast5" name="txtDateLast5" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            Inhalants<span className='small'>
                                (LSD, PCP, mushrooms) </span>
                        </td>
                        <td className='w-100'>
                            <input type="text" id="txtAgeIst6" name="txtAgeIst6" className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type="text" id="txtAgHeaviest6" name="txtAgHeaviest6" className='add-only' />
                        </td>
                        <td className='w-200'>
                            <input type="text" id="txtFrequency6" name="txtFrequency6" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="date" id="txtDateLast6" name="txtDateLast6" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            Opioids
                            <span className='small'> (Heroine, Narcotics, Methadone)  </span>
                        </td>
                        <td className='w-100'>
                            <input type="text" id="txtAgeIst7" name="txtAgeIst7" className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type="text" id="txtAgHeaviest7" name="txtAgHeaviest7" className='add-only' />
                        </td>
                        <td className='w-200'>
                            <input type="text" id="txtFrequency7" name="txtFrequency7" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="date" id="txtDateLast7" name="txtDateLast7" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            Sedative/Hypnotics
                            <span className='small'>(Valium, Xanax) </span>
                        </td>
                        <td className='w-100'>
                            <input type="text" id="txtAgeIst8" name="txtAgeIst8" className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type="text" id="txtAgHeaviest8" name="txtAgHeaviest8" className='add-only' />
                        </td>
                        <td className='w-200'>
                            <input type="text" id="txtFrequency8" name="txtFrequency8" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="date" id="txtDateLast8" name="txtDateLast8" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            Designer Drugs
                            <span className='small'> (Herbal, Steroids, Cough Syrup)  </span>
                        </td>
                        <td className='w-100'>
                            <input type="text" id="txtAgeIst9" name="txtAgeIst9" className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type="text" id="txtAgHeaviest9" name="txtAgHeaviest9" className='add-only' />
                        </td>
                        <td className='w-200'>
                            <input type="text" id="txtFrequency9" name="txtFrequency9" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="date" id="txtDateLast9" name="txtDateLast9" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            Tobacco
                        </td>
                        <td className='w-100'>
                            <input type="text" id="txtAgeIst10" name="txtAgeIst10" className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type="text" id="txtAgHeaviest10" name="txtAgHeaviest10" className='add-only' />
                        </td>
                        <td className='w-200'>
                            <input type="text" id="txtFrequency10" name="txtFrequency10" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="date" id="txtDateLast10" name="txtDateLast10" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            Other  <input type="text" id="txtFrequencyOther" name="txtFrequencyOther" className='add-only w-110' />
                        </td>
                        <td className='w-100'>
                            <input type="text" id="txtAgeIst11" name="txtAgeIst11" className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type="text" id="txtAgHeaviest11" name="txtAgHeaviest11" className='add-only' />
                        </td>
                        <td className='w-200'>
                            <input type="text" id="txtFrequency11" name="txtFrequency11" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="date" id="txtDateLast11" name="txtDateLast11" className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>What consequences has the Individual faced as a result of the Drug/Alcohol use?</span><span className='small'>(Include hangovers, DT's, Blackouts, Binges, Overdoses, Seizures, GI Bleeding, Job Loss, DUI's, Assaults, Incarcerations, Homicides, etc)</span>
                    Be sure to ask about legal problems, family problems, school/work problems, mental health problems that have been impacted by their use of drugs.
                    <textarea id="txtConsequences" name="txtConsequences" className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Longest period of sobriety?</span>
                            <input type="text" id="txtLongest" name="txtLongest" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>When?</span>
                            <input type="date" id="txtWhen" name="txtWhen" className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                <h3>
                    Health Issues/Medical History</h3>
                    <textarea id='txtHealthIssues' name='txtHealthIssues' className='add-only'></textarea> 
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Current Health Issues:</span>
                    <input type="checkbox" id="cbCurrent" name="cbCurrent" className='add-only' value="None" /> None reported
                </p>
                <p className='w-750'>
                    Who is treating this medical issue:<input type="text" id="txtMedical" name="txtMedical" className='add-only' />
                </p>
                <p className='w-750'>
                    If none, make referral and coordinate services.
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Past Health Issues:</span>
                    <input type="checkbox" id="cbCurrent1" name="cbCurrent1" className='add-only' value="None1" /> None reported
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Hearing</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbHearing1" name="cbHearing1" className='add-only' value="Hearing1" />  WNL
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbHearing2" name="cbHearing2" className='add-only' value="Hearing2" /> Impaired
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbHearing3" name="cbHearing3" className='add-only' value="Hearing3" /> Needs follow-up
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Vision</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbHearing4" name="cbHearing4" className='add-only' value="Hearing4" /> WNL
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbHearing5" name="cbHearing5" className='add-only' value="Hearing5" /> Impaired
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbHearing6" name="cbHearing6" className='add-only' value="Hearing6" /> Needs follow-up
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbHearing7" name="cbHearing7" className='add-only' value="Hearing7" /> Wears glasses
                        </td>
                        <td className='w-250'>
                            &nbsp;
                        </td>
                        <td className='w-250'>
                            &nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Speech</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSpeech4" name="cbSpeech4" className='add-only' value="Speech4" /> WNL
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSpeech5" name="cbSpeech5" className='add-only' value="Speech5" /> Impaired
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSpeech6" name="cbSpeech6" className='add-only' value="Speech6" /> Needs follow-up
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Immunizations</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbImmunizations1" name="cbImmunizations1" className='add-only' value="Immunizations1" />  Up to date
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbImmunizations2" name="cbImmunizations2" className='add-only' value="Immunizations2" /> Needs follow-up
                        </td>
                        <td className='w-250'>
                            &nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Self-Identification of Infectious Diseases</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbImmunizations3" name="cbImmunizations3" className='add-only' value="Immunizations3" /> None reported
                        </td>
                        <td className='w-250'>
                            &nbsp;
                        </td>
                        <td className='w-250'>
                            &nbsp;
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Pregnant</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="radio" id="rbPregnant_Yes" name="rbPregnant" className='add-only' value="1" /> Yes
                        </td>
                        <td className='w-250'>
                            <input type="radio" id="rbPregnant_No" name="rbPregnant" className='add-only' value="0" /> No
                        </td>
                        <td className='w-250'>
                            <input type="radio" id="rbPregnant_Np" name="rbPregnant" className='add-only' value="2" /> N/A
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>If Yes, Receiving Pre-Natal Care</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="radio" id="rbPregnant1_Yes" name="rbPregnant1" className='add-only' value="1" /> Yes
                        </td>
                        <td className='w-250'>
                            <input type="radio" id="rbPregnant1_No" name="rbPregnant1" className='add-only' value="0" /> No
                        </td>
                        <td className='w-250'>
                            &nbsp;
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>INDIVIDUAL'S LEGAL HISTORY</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cbProbation1" name="cbProbation1" className='add-only' value="Probation1" /> Probation Officer Contact and County:
                        </td>
                        <td className='w-375'>
                            <input type="text" id="txtProbation1" name="txtProbation1" className="FormTextbox dd" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cbProbation2" name="cbProbation2" className='add-only' value="Probation2" /> Parole Officer Contact and County:
                        </td>
                        <td className='w-375'>
                            <input type="text" id="txtProbation2" name="txtProbation2" className="FormTextbox dd" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cbProbation3" name="cbProbation3" className='add-only' value="Probation3" /> Number of Arrest in Past 30 Days:
                        </td>
                        <td className='w-375'>
                            <input type="text" id="txtProbation3" name="txtProbation3" className="FormTextbox dd" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cbProbation4" name="cbProbation4" className='add-only' value="Probation4" /> Number of arrests in the past year:
                        </td>
                        <td className='w-375'>
                            <input type="text" id="txtProbation4" name="txtProbation4" className="FormTextbox dd" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cbProbation5" name="cbProbation5" className='add-only' value="Probation5" /> Current Pending Charges:
                        </td>
                        <td className='w-375'>
                            <input type="text" id="txtProbation5" name="txtProbation5" className="FormTextbox dd" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cbProbation6" name="cbProbation6" className='add-only' value="Probation" /> DFCS/CPS and County
                        </td>
                        <td className='w-375'>
                            &nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cbProbation7" name="cbProbation7" className='add-only' value="Probation" /> Restraining Order
                        </td>
                        <td className='w-375'>
                            &nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cbProbation8" name="cbProbation8" className='add-only' value="Probation" /> None
                        </td>
                        <td className='w-375'>
                            &nbsp;
                        </td>
                    </tr>
                </table>
                <h3>
                    G. EDUCATION ASSESSMENT
                </h3>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>School Currently Attending:</span>
                            <input type="text" id="txtSchool" name="txtSchool" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Current Grade:</span>
                            <input type="text" id="txtCurrentGrade" name="txtCurrentGrade" className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Literacy Level:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbLiteracy1" name="cbLiteracy1" className='add-only' value="Literacy1" /> Appropriate for Age
                        </td>
                        <td className='w-500'>
                            <input type="checkbox" id="cbLiteracy2" name="cbLiteracy2" className='add-only' value="Literacy2" /> Defaulting Reading or Writing- Explain:
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <textarea id="txtExplain" name="txtExplain" className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>INTELLECTUAL FUNCTIONING</span>
                            <span className='small'>(Estimate)</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbEstimate1" name="cbEstimate1" className='add-only' value="Estimate1" /> Above Avg;
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbEstimate2" name="cbEstimate2" className='add-only' value="Estimate2" /> Normal/Avg.
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbEstimate3" name="cbEstimate3" className='add-only' value="Estimate3" /> Borderline;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Intellectual Disabilities :</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbEstimate4" name="cbEstimate4" className='add-only' value="Estimate4" /> Mild
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbEstimate5" name="cbEstimate5" className='add-only' value="Estimate5" /> Moderate
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbEstimate6" name="cbEstimate6" className='add-only' value="Estimate6" /> Severe
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbEstimate7" name="cbEstimate7" className='add-only' value="Estimate7" /> Other/Describe:
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <textarea id="txtExplainDescribe" name="txtExplainDescribe" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Is the Individual in special classes? If so, what type?</span>
                    <input type="radio" id="rbIntellectual5_Yes" name="rbIntellectual5" className='add-only' value="1" /> Yes &nbsp;
                    <input type="radio" id="rbIntellectual5_No" name="rbIntellectual5" className='add-only' value="0" /> No
                    <input type="text" id="txtType" name="txtType" className='add-only' />
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Has the Individual ever been suspended or expelled from school and/or bus? </span><span className='small'> (Include both in-school suspensions and out-of-school suspensions)</span>
                    <input type="radio" id="rbMedications12_Yes" name="rbMedications12" className='add-only' value="1" /> Yes &nbsp;
                    <input type="radio" id="rbMedications12_No" name="rbMedications12" className='add-only' value="0" /> No
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Does the Individual have frequent absences, truancy?</span>
                    <input type="radio" id="rbMedications21_Yes" name="rbMedications21" className='add-only' value="1" /> Yes &nbsp;
                    <input type="radio" id="rbMedications21_No" name="rbMedications21" className='add-only' value="0" /> No
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Does the Individual need or is receiving tutoring services?</span>
                    <input type="radio" id="rbMedications31_Yes" name="rbMedications31" className='add-only' value="1" /> Yes &nbsp;
                    <input type="radio" id="rbMedications31_No" name="rbMedications31" className='add-only' value="0" /> No
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Is the Individual currently failing, and has the Individual ever been retained?</span>
                    <input type="radio" id="rbMedications41_Yes" name="rbMedications41" className='add-only' value="1" /> Yes &nbsp;
                    <input type="radio" id="rbMedications41_No" name="rbMedications41" className='add-only' value="0" /> No
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>What does the Individual like and dislike about school?</span>
                    <textarea id="txtExplainDescribe2" name="txtExplainDescribe2" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Describe Individual's Peer relationships? </span><span className='small'>(Include both the Individual and parent's descriptions)</span>
                    <textarea id="txtExplainDescribe3" name="txtExplainDescribe3" className='add-only'></textarea>
                </p>
                <h3>
                    H. SEXUALITY
                </h3>
                <p className='w-750'>
                    <span className='eleHeader'>How would you describe your relationship with your current partner?</span>
                    <textarea id="txtPartner" name="txtPartner" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Is there violence of history of violence in past or current relationships?</span>
                    <input type="radio" id="rbMedications6_Yes" name="rbIntellectual6" className='add-only' value="1" /> Yes &nbsp;
                    <input type="radio" id="rbMedications6_No" name="rbIntellectual6" className='add-only' value="0" /> No
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>How would you describe your sexual preference/orientation/gender expression? </span><span className='small'>(Heterosexual, Homosexual, Bi-Sexual, Masculine,
                        Feminine, etc.)</span>
                    <textarea id="txtPartner1" name="txtPartner1" className='add-only'></textarea>
                </p>
                <h3>
                    I. ETHNIC/CULTURAL ORIENTATION <span className='small'>(Check all that apply)</span>
                </h3>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>What type of community were you raised in:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbLarge1" name="cbLarge1" className='add-only' value="Large1" /> Large City
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbLarge2" name="cbLarge2" className='add-only' value="Large2" /> Medium Size city
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbLarge3" name="cbLarge3" className='add-only' value="Large3" />  Large Town
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbLarge4" name="cbLarge4" className='add-only' value="Large4" /> Small Town
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbLarge5" name="cbLarge5" className='add-only' value="Large5" /> Rural
                        </td>
                        <td className='w-250'>
                            &nbsp;
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>What cultural practices linked to your racial/ethnic background is important to you?</span>
                    <textarea id="txtPartner3" name="txtPartner3" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>What are your hobbies or leisure preferences:</span>
                    <textarea id="txtPartner4" name="txtPartner4" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>What are your spiritual preferences:</span>
                    <textarea id="txtPartner5" name="txtPartner5" className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>What community involvement do you engage in:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbEngage1" name="cbEngage1" className='add-only' value="Engage1" /> Volunteer
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbEngage2" name="cbEngage2" className='add-only' value="Engage2" /> Employment
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbEngage3" name="cbEngage3" className='add-only' value="Engage3" /> Church
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbEngage4" name="cbEngage4" className='add-only' value="Engage4" /> Family Activities
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbEngage5" name="cbEngage5" className='add-only' value="Engage5" /> Sports
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbEngage6" name="cbEngage6" className='add-only' value="Engage6" /> None
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Would you like to be more involved in the community:Yes/No If yes, what would you like to do:</span>
                    <input type="radio" id="rbMedications7_Yes" name="rbIntellectual7" className='add-only' value="1" /> Yes &nbsp;
                    <input type="radio" id="rbMedications7_No" name="rbIntellectual7" className='add-only' value="0" /> No
                    <input type="text" id="txtType3" name="txtType3" className='add-only' />
                </p>
                <h3>
                    J. SNAP: STRENGTHS, NEEDS, ABILITIES, PREFERENCES
                </h3>
                <p className='w-750'>
                    <span className='eleHeader'>What strengths does the Individual have that affects their quality of life? </span> <span className='small'>(This should include family, friend, teacher supports, hobbies, community resources, education)</span>
                    Please provide a quote in each box of the individuals answer and then add your clinical assessment for all items in sections P and Q.
                    <textarea id="txtPartner7" name="txtPartner7" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>What is needed to increase the Individual quality of life?</span><span className='small'>(Name specific interventions, resources for biological, psychological, and social/environmental barriers)</span>
                    <textarea id="txtPartner8" name="txtPartner8" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>What are the Individual abilities and skills that would help increase his/her quality of life? </span><span className='small'>(This should include personality traits, work skills, academic skills)</span>
                    <textarea id="txtPartner9" name="txtPartner9" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>What strengths does the parent believe the Individual has?</span>
                    <textarea id="txtPartner10" name="txtPartner10" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>What are the family's strengths?</span>
                    <textarea id="txtPartner11" name="txtPartner11" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>What are the Individual and family's expectation of and preferences for this service?</span><span className='small'>(This should include the Individual own words of his/her expected outcome)</span>
                    <textarea id="txtPartner12" name="txtPartner12" className='add-only'></textarea>
                </p>
                <h3>
                    K. Hopes / Choices / Preferences / Desired Outcomes
                </h3>
                <p className='w-750'>
                    <span className='eleHeader'>What Hopes does the Individual have regarding their treatment?</span><span className='small'>(This should include family, friend, teacher supports, hobbies, community resources, education)</span>
                    <textarea id="txtPartner14" name="txtPartner14" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>What Choices does the Individual have regarding meeting his/her needs?</span><span className='small'>(Name specific resources, community opportunities, etc.)</span>
                    <textarea id="txtPartner15" name="txtPartner15" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>What Preferences does the Individual have regarding his/her treatment?</span><span className='small'>(This should male/female community staff, meeting location and/or time, staff with specific specialty, etc.)</span>
                    <textarea id="txtPartner16" name="txtPartner16" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>What are the Individual's Desired Outcomes for treatment?</span><span className='small'>(What does the Individual expect to achieve throughout his/her treatment?)</span>
                    <textarea id="txtPartner17" name="txtPartner17" className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>L . NIOP PROGRAM QUALIFIERS
                            </span> <span className='small'>(Check all that apply)</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbIndividual1" name="cbIndividual1" className='add-only' value="Individual1" /> Individual is affected by an emotional disturbance or substance related disorder.
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbIndividual2" name="cbIndividual2" className='add-only' value="Individual2" /> Individual has shown early indications of behaviors that could be disruptive to the community and the family/support system if
                            behavior intensified.2
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbIndividual3" name="cbIndividual3" className='add-only' value="Individual3" /> Individual has shown early indications behaviors/ functional problems that could cause risk of removal from the home if problems
                            intensified.
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbIndividual4" name="cbIndividual4" className='add-only' value="Individual4" />  Individual has shown early indications of poor school performance (poor grades, disruptive behavior, lack of motivation,
                            suspension).
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbIndividual5" name="cbIndividual5" className='add-only' value="Individual5" />  Individual has shown early indications of delinquent behaviors that could result in legal system involvement.
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbIndividual6" name="cbIndividual6" className='add-only' value="Individual6" /> Individual has shown early indications of behavioral/functional problems that could result in multiple agency involvement if
                            problems intensified.
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbIndividual7" name="cbIndividual7" className='add-only' value="Individual7" /> Individual demonstrates behaviors that are a risk of harm to self, others, or property.
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbIndividual8" name="cbIndividual8" className='add-only' value="Individual8" />  Individual indicates the need for detoxification services.
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbIndividual9" name="cbIndividual9" className='add-only' value="Individual9" /> Treatment at a Lower Level of Care has been attempted or given serious consideration (Has this consumer been in outpatient care
                            or has outpatient care been considered? If considered, why not tried?).
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbIndividual10" name="cbIndividual10" className='add-only' value="Individual10" /> Individual and/or family have insufficient or severely limited resources or skills to cope with an immediate crisis.
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbIndividual11" name="cbIndividual11" className='add-only' value="Individual11" /> Individual and/or family issues are unmanageable in traditional outpatient treatment and require intensive, coordinate clinical and
                            supportive intervention.
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbIndividual12" name="cbIndividual12" className='add-only' value="Individual12" />  Individual is at immediate risk for out-of-home placement or is currently in out-of-home placement and reunification imminent.
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>If any of the above were checked, please provide details below.</span>
                    <textarea id="txtDetails1" name="txtDetails1" placeholder="Must Complete" className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>M. INTENSIVE FAMILY INTERVENTION (IFI) PROGRAM QUALIFIERS
                    </span><span className='small'>(check all that apply)</span>
                    Youth has a diagnosis and duration of symptoms which classify that illness as SED and/or diagnosed Substance Related Disorder.

                </p>
                <h4>
                    ONE OR MORE OF THE FOLLOWING:
                </h4>
                <table>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbIntensive2" name="cbIntensive2" className='add-only' value="Intensive2" /> Youth has received documented services through other services modalities (such as NIOP services) and/or exhausted less intensive outpatient
                            services. Treatment at a lower intensity has been attempted or given serious consideration, but the risk factors for out-of-home placement are
                            compelling.
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbIntensive3" name="cbIntensive3" className='add-only' value="Intensive3" /> Youth and/or family have insufficient or severely limited resources or skills necessary to cope with an immediate behavioral health crisis.
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbIntensive4" name="cbIntensive4" className='add-only' value="Intensive4" /> Youth and/or family behavioral health issues are unmanageable in traditional outpatient treatment and require intensive, coordinated clinical
                            and supportive intervention.
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbIntensive5" name="cbIntensive5" className='add-only' value="Intensive5" /> Because of behavioral health issues, the youth is at immediate risk of out-of-home placement or is currently in out-of-home placement and
                            reunification is imminent (therefore, intensive work needs to begin with the youth and family regarding the youth's treatment goals.)
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbIntensive6" name="cbIntensive6" className='add-only' value="Intensive6" />  Because of behavioral health issues, the youth is at immediate risk of legal system intervention or is currently involved with DJJ for
                            behaviors/issues related to SED and/or the Substance-related disorder.
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>If any of the above were checked, please provide details below and discuss referral with Clinical Director.</span>
                    <textarea id="txtDetails2" name="txtDetails2" className='add-only'></textarea>
                </p>
                <h3>
                    N. Stage of Change: Indicate the current stage of change the individual is in for each of their issues and provide supporting
                    evidence of your assessment.
                </h3>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>What Stage of Change is the Individual In:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="radio" id="rbMedications5_Yes" name="rbMedications5" className='add-only' value="1" /> 1. Pre-Contemplation (No intentions of changing)
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="radio" id="rbMedications5_Ys" name="rbMedications5" className='add-only' value="2" /> 2. Contemplation (Recognizing there's a problem
                            with no commitment to change)
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="radio" id="rbMedications5_Ye" name="rbMedications5" className='add-only' value="3" /> 3. Preparation (Intent upon taking action soon and
                            often report some steps in that direction)
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="radio" id="rbMedications5_No" name="rbMedications5" className='add-only' value="0" /> 4. Action (Is aware a problem exists and actively
                            modifies their behavior, experiences and
                            environment in order to overcome the problem.
                            Commitment is clear and a great deal of effort is
                            expended towards making changes)
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="radio" id="rbMedications5_Ni" name="rbMedications5" className='add-only' value="5" /> 5. Maintenance (Has made a sustained change
                            wherein a new pattern of behavior has replaced
                            the old. Behavior is firmly established and threat
                            of relapse becomes less intense)
                        </td>
                    </tr>
                </table>
                <p className='w-750'>***(Relapse)
                </p>
                <p className='w-750'>
                    Remember the individual can be at different stages of change for
                    each of their issues. Be sure to note that... for instance.... they are in
                    the preparation stage when it comes to depression but in precontemplation
                    or relapse when it comes to their drug use.
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>O. DIAGNOSTIC IMPRESSION </span><span className='small'>(ICD-10 Codes)</span>
                    Place the DSM V and ICD 10 codes as well as spell out the diagnoses in this box.
                    <textarea id="txtImpression" name="txtImpression" className='add-only'></textarea>
                </p>
                <h3>
                    P. INTERPRETIVE SUMMARY
                </h3>
                <p className='w-750'>
                    <span className='eleHeader'>Summary should begin with a brief description of the individual. Provide a summary that integrates all sections of the assessment
                        (1-2 lines summarizing the presenting problem. Provide history of treatment and progress or lack thereof along with confirmed
                        diagnosis and psychotropic medication. Provide information on medical history and medication prescribed. Information on legal
                        and substance use history, etc.) Indicate individual's acceptance or understanding of his/her problems. Provide an explanation of
                        goals the individual wants to work on and if individual refuses to address specific goals/challenges provide explanation here.
                        Indicate the services recommended and how they will assist the individual with addressing their needs. Discuss the individual's
                        strengths and limitations and how they will affect treatment.</span>
                    Make sure this is a narrative explaining the full picture of the individual here, do not copy and paste items from above... make sure this helps all outside readers understand why you recommend or do not recommend services for this individual.
                    <textarea id="txtImpression2" name="txtImpression2" className='add-only'></textarea>
                </p>
                <h3>
                    Q. Progress Made from Previous Treatment
                </h3>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Please indicate the level in which the Individual has made progress within their treatment.</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="radio" id="rbProgress_Yes" name="rbProgress" className='add-only' value="1" /> N/A - This is a New Intake. Progress will be monitored throughout treatment.
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="radio" id="rbProgress_Ys" name="rbProgress" className='add-only' value="2" /> Minimal Progress Made
                        </td>
                        <td className='w-250'>
                            <input type="radio" id="rbProgress_Ye" name="rbProgress" className='add-only' value="3" /> Moderate Progress Made
                        </td>
                        <td className='w-250'>
                            <input type="radio" id="rbProgress_Yep" name="rbProgress" className='add-only' value="4" /> Goal Fully Achieved
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>What's the evidenced in which progress has / has not been made?</span>
                    <textarea id="txtImpression1" name="txtImpression1" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    Example: Individual has made moderate progress with goal 3; as evidenced by increasing her conflict resolution skills with her
                    siblings to 0-1 fight per month; versus previously reports of 2-3 fights per month.
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>R. RECOMMENDED SERVICES
                            </span><span className='small'>(select all that apply):</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbService1" name="cbService1" className='add-only' value="Service1" /> Individual Counseling/Therapy (90832, 90834, 90837)
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbService2" name="cbService2" className='add-only' value="Service2" />  Family Counseling/Therapy (90846, 90847, H0004)
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbService3" name="cbService3" className='add-only' value="Service3" /> Consumer Support (H2015)
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbService4" name="cbService4" className='add-only' value="Service4" /> Family Skills Training (H2014)
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbService5" name="cbService5" className='add-only' value="Service5" />  Psychiatric Treatment and Medication Management
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbService6" name="cbService6" className='add-only' value="Service6" /> Intensive Family Intervention (IFI)
                        </td>
                    </tr>
                </table>
                <ul>
                    <li>
                        Upon the completion of the Assessment, if IFI services are recommended, please inform the Clinical Director.
                    </li>
                    <li>
                        Behaviors to consider when referring to IFI:
                    </li>
                    <li>
                        Frequent hospitalizations
                    </li>
                    <li>
                        History SI/HI/Self-Harming
                    </li>
                    <li>
                        History or current legal involvement (within the past 180 days)
                    </li>
                    <li>
                        History or current school suspensions
                    </li>
                    <li>
                        Behaviors that may require services to be rendered more that 3 days per week
                    </li>
                </ul>
                <h3>
                    COMPLETED BY:
                </h3>
                <h4>
                    (Please include credentials after your name)
                </h4>
                <table>
                    <tr>
                        <td className='w-450 signature'  >&nbsp; </td>
                        <td className='w-300 signature'  >&nbsp; </td>
                    </tr>
                    <tr>
                        <td className="w-450 small">Assessor Signature: </td>
                        <td className="w-300 small">Date: </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-450 signature'  >&nbsp; </td>
                        <td className='w-300 signature'  >&nbsp; </td>
                    </tr>
                    <tr>
                        <td className="w-450 small">Assessor Print Name: </td>
                        <td className="w-300 small">Date: </td>
                    </tr>
                </table>
                <h3>
                    REVIEWED BY (If Applicable):
                </h3>
                <h4>
                    (Please include credentials after your name)
                </h4>
                <table>
                    <tr>
                        <td className='w-450 signature'  >&nbsp;
                        </td>
                        <td className='w-300 signature'  >&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className="small">Licensed Professional Signature:
                        </td>
                        <td className="small">Date:
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450 signature'  >&nbsp;
                        </td>
                        <td className='w-300 signature'  >&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className="small">Licensed Professional Print Name:
                        </td>
                        <td className="small">Date:
                        </td>
                    </tr>
                </table>



            </div>
        </form >

    )
}











